/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class QuestionTypeChildren {
    public static readonly sign: string = "Sign";
    public static readonly assertion: string = "Assertion";
}
